window.productDetailFormatter = function(value, row) {
    let html = '';
    if (!row.generalLedgerAccount) {
        return html;
    }
    html += '<table class="table table-borderless table-hover table-responsive table-sm table-striped text-nowrap">';
    html += '<thead>';
    html += '<tr>';
    html += '<th style="padding: 8px; width: 220px !important">'+__('Revenue')+'</th>';
    html += '<th style="padding: 8px; width: 220px !important">'+__('Code')+'</th>';
    html += '<th style="padding: 8px; width: 220px !important">'+__('GUID')+'</th>';
    html += '</tr>';
    html += '</thead>';
    html += '<tbody>';
    html += '<tr>';
    html += '<td style="padding: 8px">'+row.generalLedgerAccount.name+'</td>';
    html += '<td style="padding: 8px">'+row.generalLedgerAccount.code+'</td>';
    html += '<td style="padding: 8px">'+row.generalLedgerAccount.guid+'</td>';
    html += '</tr>';
    html += '</tbody>';
    html += '</table>';
    return html;
};
